
import React from 'react';
import { Button } from '@/components/ui/button';
import { useAuthTabSwitcher } from '@/hooks/useAuthTabSwitcher';
import { useLoginForm } from './login/useLoginForm';
import LoginError from './login/LoginError';
import VerificationControls from './login/VerificationControls';
import LoginFormFields from './login/LoginFormFields';
import { Sparkles } from 'lucide-react';

const LoginForm = () => {
  const { switchTab } = useAuthTabSwitcher();
  const {
    email,
    setEmail,
    password,
    setPassword,
    loading,
    error,
    resendLoading,
    verificationNeeded,
    handleLogin,
    handleResendVerification
  } = useLoginForm();

  const handleForgotPassword = () => {
    // Dispatch custom event to set email in reset form
    const event = new CustomEvent('set-reset-email', { detail: email });
    window.dispatchEvent(event);
    
    // Switch to reset tab
    switchTab('reset');
  };

  return (
    <form onSubmit={handleLogin} className="space-y-4">
      <LoginError error={error} />
      
      <LoginFormFields
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
        loading={loading}
        handleForgotPassword={handleForgotPassword}
      />

      <Button 
        type="submit" 
        className="w-full bg-brand text-white font-semibold rounded-xl gap-2" 
        disabled={loading}
      >
        {loading ? "Signing in..." : "Sign In"}
        {!loading && <Sparkles className="h-4 w-4" />}
      </Button>
      
      <VerificationControls
        verificationNeeded={verificationNeeded}
        handleResendVerification={handleResendVerification}
        resendLoading={resendLoading}
      />
      
      <div className="text-center text-sm mt-4">
        <span className="text-muted-foreground">Don't have an account?</span>{" "}
        <button
          type="button"
          onClick={() => switchTab('signup')}
          className="text-brand hover:underline bg-transparent border-none p-0 cursor-pointer font-medium"
          disabled={loading}
        >
          Sign up for free
        </button>
      </div>
    </form>
  );
};

export default LoginForm;
